import { useReducer } from 'react';
const initialState = 0;
function counter(prevState, _action) {
  return prevState + 1;
}

/**
 * An escape-hatch to force a component to render. It is strongly advised not to use this
 * in typical development.
 *
 * Named after the `forceUpdate` method in class components. This is akin to openui5's
 * invalidate on Controls.
 *
 * The returned function reference will not change between renders. However, you should
 * still include it in input arrays for other hooks.
 *
 * @see https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
 *
 * @example
 * ```
 * function MyComponent(props) {
 *   const forceUpdate = useForceUpdate();
 *   useEffect(function onUpdate() {
 *     // every time we render, schedule another render in 2 seconds
 *     setTimeout(() => forceUpdate(), 2000);
 *   });
 *
 *   return null;
 * }
 * ```
 */
export default function useForceUpdate() {
  const [, dispatch] = useReducer(counter, initialState);
  return dispatch;
}
//# sourceMappingURL=useForceUpdate.js.map